import { render, staticRenderFns } from "./SensorCard2.vue?vue&type=template&id=2555641c&scoped=true&"
import script from "./SensorCard2.vue?vue&type=script&lang=js&"
export * from "./SensorCard2.vue?vue&type=script&lang=js&"
import style0 from "./SensorCard2.vue?vue&type=style&index=0&id=2555641c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2555641c",
  null
  
)

export default component.exports